import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
const STORAGE_KEY = 'state';
export class ConfiguracionService {
    constructor() {
        this.datosSubject = new BehaviorSubject({ ejercicio: 0, esProcesoElectoral: false });
        this.datos$ = this.datosSubject.asObservable();
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
            this.datosSubject.next(JSON.parse(stored));
        }
    }
    actualizar(parcial) {
        const actual = this.datosSubject.value;
        const actualizado = Object.assign({}, actual, parcial);
        this.datosSubject.next(actualizado);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(actualizado));
    }
    getDatos() {
        return this.datosSubject.value;
    }
    limpiar() {
        const limpio = { ejercicio: 0, esProcesoElectoral: false };
        this.datosSubject.next(limpio);
        localStorage.removeItem(STORAGE_KEY);
    }
}
ConfiguracionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ConfiguracionService_Factory() { return new ConfiguracionService(); }, token: ConfiguracionService, providedIn: "root" });
